<template>
  <div class="row align-items-start">
    <div v-if="editable"
         class="col-md-6 col-sm-12 col-input">
      <json-editor
        @input="emitter"
        v-model="schema">
      </json-editor>
    </div>
    <div
      v-bind:class="{'col-md-6': editable}"
      class="col-sm-12 col-preview">
      <quiz-preview
        :schema="schemaCandidate"
        v-model="model"
        @submit="onAnswer"
        :show-submit="!editable">
      </quiz-preview>
    </div>
  </div>
</template>

<script>
  import JsonEditor from "../Editors/JsonEditor";
  import QuizPreview from "./QuizPreview";

  export default {
    name: "QuizGenerator",
    components: {
      QuizPreview,
      JsonEditor,
    },
    props: {
      value: {
        type: String
      },
      editable: {
        type: Boolean,
        default: false,
        description: "Show Json editor to edit form schema"
      },
    },
    data() {
      return {
        model: {},
        formOptions: {
          validateAfterLoad: true,
          validateAfterChanged: true
        },
        schema: ""
      };
    },
    mounted() {
      if (this.value) {
        this.schema = this.value;
      }
    },
    computed: {
      schemaCandidate() {
        try {
          return JSON.parse(this.schema)
        } catch (e) {
          return {questions: []}
        }
      }
    },
    methods: {
      onAnswer(val) {
        this.$emit("onAnswer", val)
      },
      emitter(val) {
        this.$emit("input", val)
      }
    }
  }
</script>

<style scoped>

</style>
